// actions.js - Действия для загрузки конфигурации UID
// SPRINT_10: Кэширование конфигурации UID в Redux

export const LOAD_UID_CONFIG = 'LOAD_UID_CONFIG';
export const LOAD_UID_CONFIG_SUCCESS = 'LOAD_UID_CONFIG_SUCCESS';
export const LOAD_UID_CONFIG_FAILURE = 'LOAD_UID_CONFIG_FAILURE';
export const INVALIDATE_UID_CONFIG = 'INVALIDATE_UID_CONFIG';

/**
 * Действие для начала загрузки конфигурации UID
 * @param {number} uidId - ID UID профиля
 */
export const loadUidConfig = (uidId) => ({
  type: LOAD_UID_CONFIG,
  payload: { uidId },
});

/**
 * Действие для успешной загрузки конфигурации UID
 * @param {number} uidId - ID UID профиля
 * @param {Object} config - Конфигурация UID (станции, теги, компоненты, правила, тренды, группы, команды)
 */
export const loadUidConfigSuccess = (uidId, config) => ({
  type: LOAD_UID_CONFIG_SUCCESS,
  payload: { uidId, config },
});

/**
 * Действие для ошибки загрузки конфигурации UID
 * @param {number} uidId - ID UID профиля
 * @param {string} error - Сообщение об ошибке
 */
export const loadUidConfigFailure = (uidId, error) => ({
  type: LOAD_UID_CONFIG_FAILURE,
  payload: { uidId, error },
});

/**
 * Действие для инвалидации кэша конфигурации UID
 * @param {number} uidId - ID UID профиля
 */
export const invalidateUidConfig = (uidId) => ({
  type: INVALIDATE_UID_CONFIG,
  payload: { uidId },
});

